import { ScrollModal } from "../../../../shared/scroll-modal";
import { SongCard } from "../../song-list/song-card";
import { parseTime } from "../../../../../utils/utils";
import React, { forwardRef, useRef } from "react";
import { ScrollModalApi } from "../../../../shared/scroll-modal/view";
import useSongStore from "../../store/SongState";
import { useScreenSize } from "../../../../../hooks";
import { RightPanelModal, RightPanelModalApi } from "../../../../shared/right-panel-modal";

import './styles.scss';
import { Song } from "../../types";
import SeparatorLine from "../../../../shared/separator-line/separator-line";

enum SongQueueOptions {
    QUEUE = "queue",
    HISTORY = "history"
}

const SongQueueScrollModalView = forwardRef<ScrollModalApi, any>((props, ref) => {
    const { state, setCurrentSong } = useSongStore(state => state);
    const { currentSong, songQueue, songHistory } = state;
    const [option, setOption] = React.useState(SongQueueOptions.QUEUE);
    const { width } = useScreenSize();

    const scrollModalRef = useRef<ScrollModalApi>(null);
    const rightPanelModalRef = useRef<RightPanelModalApi>(null);

    React.useImperativeHandle(ref, () => ({
        open: (e) => {
            if (width > 1200) {
                rightPanelModalRef.current?.open();
            } else {
                scrollModalRef.current?.open(e);
            }
        },
        close: () => {
            rightPanelModalRef.current?.close();
            scrollModalRef.current?.close();
        },
        isOpen: scrollModalRef.current?.isOpen || rightPanelModalRef.current?.isOpen
    }));

    const songPlayOption = (song: Song) => {
        return (
            <div style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
            }}>
                <i style={{
                    padding: "0 0.7rem",
                    color: "white",
                }}
                    onClick={() => setCurrentSong(song)}
                    className="fa-solid fa-play"></i>
            </div>)
    }

    if (width > 1200) {
        return (
            <RightPanelModal
                ref={rightPanelModalRef}
                tabs={[
                    {
                        id: "queue",
                        label: "Cola",
                        content: (
                            <div className="audio-player__song-queue-modal__body pt-2 pb-4">
                                <span className="text-light">Sonando:</span>
                                {currentSong && <SongCard song={currentSong} key={currentSong.id} ableHovering={true} extraDetails={
                                    <div style={{
                                        fontWeight: "bold",
                                        letterSpacing: "0.1px",
                                        fontSize: "0.8rem",
                                        overflow: "hidden",
                                        color: "rgba(190,190,190,0.7)"
                                    }}>{currentSong.user.username} · {parseTime(currentSong.duration)}</div>
                                } />}
                                {songQueue.length > 0 && <>
                                    <SeparatorLine />
                                    <span className="text-light pt-2">A continuación:</span>
                                    {songQueue.map((song, index) => (
                                        <SongCard song={song} key={song.id + '-' + index} extraDetails={
                                            <div style={{
                                                fontWeight: "bold",
                                                letterSpacing: "0.1px",
                                                fontSize: "0.8rem",
                                                overflow: "hidden",
                                                color: "rgba(190,190,190,0.7)"
                                            }}>{song.user.username} · {parseTime(song.duration)}</div>
                                        }
                                            customOptions={songPlayOption(song)} />
                                    ))}
                                </>}
                            </div>
                        )
                    },
                    {
                        id: "history",
                        label: "Historial",
                        content: (
                            <div className="audio-player__song-queue-modal__body pb-4">
                                {songHistory.map((song, index) => (
                                    <SongCard song={song} key={`${song.id}-${index}`} extraDetails={
                                        <div style={{
                                            fontWeight: "bold",
                                            letterSpacing: "0.1px",
                                            fontSize: "0.8rem",
                                            overflow: "hidden",
                                            color: "rgba(190,190,190,0.7)"
                                        }}>{song.user.username} · {parseTime(song.duration)}</div>
                                    }
                                        customOptions={songPlayOption(song)} />
                                ))}
                            </div>
                        )
                    }
                ]}
            />
        );
    }

    return (
        <ScrollModal header={
            <div className="audio-player__song-queue-modal">
                <div
                    className={[
                        "audio-player__song-queue-modal__option",
                        option === SongQueueOptions.QUEUE ? "audio-player__song-queue-modal__option__selected" : ""].join(" ")}
                    onClick={() => setOption(SongQueueOptions.QUEUE)}>
                    Cola
                </div>
                <span>·</span>
                <div
                    className={[
                        "audio-player__song-queue-modal__option",
                        option === SongQueueOptions.HISTORY ? "audio-player__song-queue-modal__option__selected" : ""].join(" ")}
                    onClick={() => setOption(SongQueueOptions.HISTORY)}>
                    Historial
                </div>
            </div>} ref={scrollModalRef}>
            {option === SongQueueOptions.HISTORY && <div className="audio-player__song-queue-modal__body pt-3">
                {songHistory.map((song, index) => (
                    <SongCard song={song} key={`${song.id}-${index}`} extraDetails={
                        <div style={{
                            fontWeight: "bold",
                            letterSpacing: "0.1px",
                            fontSize: "0.8rem",
                            overflow: "hidden",
                            color: "rgba(190,190,190,0.7)"
                        }}>{song.user.username} · {parseTime(song.duration)}</div>
                    }
                        customOptions={songPlayOption(song)} />
                ))}
            </div>}
            {option === SongQueueOptions.QUEUE && <div className="audio-player__song-queue-modal__body pt-3">
                <span className="text-light">Sonando:</span>
                {currentSong && <SongCard song={currentSong} key={currentSong.id} ableHovering={true} extraDetails={
                    <div style={{
                        fontWeight: "bold",
                        letterSpacing: "0.1px",
                        fontSize: "0.8rem",
                        overflow: "hidden",
                        color: "rgba(190,190,190,0.7)"
                    }}>{currentSong.user.username} · {parseTime(currentSong.duration)}</div>
                } />}
                {songQueue.length > 0 && <span className="text-light pt-2">A continuación:</span>}
                {songQueue.map((song, index) => (
                    <SongCard song={song} key={song.id + '-' + index} extraDetails={
                        <div style={{
                            fontWeight: "bold",
                            letterSpacing: "0.1px",
                            fontSize: "0.8rem",
                            overflow: "hidden",
                            color: "rgba(190,190,190,0.7)"
                        }}>{song.user.username} · {parseTime(song.duration)}</div>
                    }
                        customOptions={songPlayOption(song)} />
                ))}
            </div>}
        </ScrollModal>
    )
});

export default SongQueueScrollModalView;
